<template>
  <div
    :class="[
      'post_gallery_sidebar',
      darkClass && 'section' in darkClass ? darkClass.section : '',
    ]"
  >
    <div class="customer-news-title">
      <div class="customer-news-text">通知公告</div>
      <div class="customer-news-more" @click="handleClickMore">更多<i class="el-icon-d-arrow-right"></i></div>
    </div>
    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'trendy' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div class="post_gallery_items" v-if="datas && datas.length > 0">
          <template v-for="(small, index) in datas.slice().sort((a, b) => b.view - a.view).slice(0, 6)">
            <text-card
              :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
              :category="true"
              :datas="small"
              :key="index"
              :index="index"
            />
          </template>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'latest' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div v-if="datas && datas.length > 0" class="post_gallery_items">
          <template v-for="(small, index) in datas.slice(0,4)">
            <row-card :category="true" :datas="small" :key="index" />
          </template>
        </div>
      </div>
    </div>

    <div class="tab-content">
      <div
        :class="[
          'tab-pane fade',
          selectedGallery === 'popular' ? 'show active' : '',
        ]"
        role="tabpanel"
        aria-labelledby="pills-home-tab"
      >
        <div v-if="datas && datas.length > 0" class="post_gallery_items">
          <template v-for="(small, index) in datas.filter(item => item.recommend === true).slice(0,4)">
            <row-card :category="true" :datas="small" :key="index" />
          </template>
        </div>
      </div>
    </div>
    
    
    <signup-style-two v-if="signup" />
   
    
    <div v-if="trendingBigPost" class="trending-sidebar mt-40">
      <div class="section-title">
        <h3 class="title">热点</h3>
      </div>
      <div class="trending-sidebar-slider position-relative">
        <span
          @click.prevent="trendingNewsPrev"
          class="prev slick-arrow"
          style="display: block"
          ><i class="fal fa-angle-left"></i
        ></span>
        <slider v-if="datas.length > 0" :settings="trendingNews" ref="trendingNews">
          <template v-for="(data, index) in datas.slice().sort((a, b) => b.view - a.view).slice(0, 8)">
            <divide-card 
              stype="col" 
              :datas="data" 
              :key="index"
              v-if="data"
            />
          </template>
        </slider>
        <span
          @click.prevent="trendingNewsNext"
          class="next slick-arrow"
          style="display: block"
          ><i class="fal fa-angle-right"></i
        ></span>
      </div>
    </div>
    
    <div v-if="ad" class="sidebar-add pt-35">
      <a href="#"><img src="@/assets/images/ads/two_ad.jpg" alt="ad" /></a>
    </div>
    
    <!--
    <share-post v-if="sharePost" class="mt-40" />
    -->
  </div>
</template>

<script>
// import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import Slider from "../../Helpers/Slider.vue";
// import SharePost from "../../Home/SharePost.vue";
import DivideCard from "../Cards/DivideCard.vue";
import TextCard from "../Cards/TextCard.vue";
import RowCard from "../Cards/RowCard.vue";
import SignupStyleTwo from "../Signup/SignupStyleTwo.vue";
export default {
  components: { 
    TextCard, 
    SignupStyleTwo, 
    DivideCard, 
    Slider, 
    RowCard
    // SharePost 
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    darkClass: {
      type: Object,
      default: () => {},
    },
    signup: {
      type: Boolean,
      default: true,
    },
    trendingBigPost: {
      type: Boolean,
      default: true,
    },
    trendingShortPost: {
      type: Boolean,
      default: true,
    },
    ad: {
      type: Boolean,
      default: true,
    },
    sharePost: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    selectedGallery: "trendy",
    trendingNews: {
      autoplay: true,
      slideToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      dots: false,
    },
    isLoading: true,
  }),
  watch: {
    datas: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.isLoading = false;
        }
      },
      immediate: true, // 组件创建时立即执行一次
      deep: true // 深度监听数组变化
    }
  },
  methods: {
    selectGalleryTab(value) {
      this.selectedGallery = value;
    },
    trendingNewsPrev() {
      this.$refs.trendingNews.prev();
    },
    trendingNewsNext() {
      this.$refs.trendingNews.next();
    },
    handleClickMore() {
      this.$router.push({ name: 'Events' });
    }
  },
  setup() {
    // const route = useRoute();

    // // 监听路由变化
    // onBeforeRouteUpdate((to, from) => {
    //   // 在这里添加重新加载数据的逻辑
    //   console.log('路由更新，重新加载数据', to, from);
    //   // 调用重新获取数据的方法
    //   // fetchData(); 
    // });

    return {
      // route
    };
  }
};
</script>

<style scoped>
/* 覆盖激活状态导航样式 */
.post_gallery_sidebar .nav li a.active {
  background: transparent !important; /* 移除父元素背景色 */
  padding-left: 0 !important; /* 左侧无内边距 */
  color: #0f5896 !important; /* 文字白色 */
  font-size: 18px;
}
.post_gallery_sidebar .nav{
  margin-bottom: 0;
}
.tab-content{
  margin-top: 10px;
}
</style>